import React from 'react'
import {isMobile} from 'react-device-detect'
import DrawerBox from '../../../components/common/DrawerBox'
import {Button} from 'antd'
import {AiFillPushpin, AiOutlineClose} from 'react-icons/ai'
import {DefaultProfileIcon} from '../../../utilities/resources'
import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/swiper-bundle.css'
import {FreeMode, Navigation} from 'swiper'
import {EMOJI_NUMBER_MAPPING, LIKE_DISLIKE, MCQ, OPINIONATED, SLIDER, SMILEY, STAR} from './ModeratorQuestionDrawer'
import ReadMoreLess from '../../../components/ReadMoreLess'

function SectionSummaryDrawer({open, setOpen, sectionSummary, sendOutSectionSummary, isAdmin}) {

    const handleCloseSummaryModal = () => {
        setOpen(false)
    }

    const percentageTag = <span style={{fontSize: 14}}>%</span>

    const getHighestPercentage = (agg) => {
        let high = 0
        agg && Object.keys(agg).forEach(key => {
            if (agg[key] > high) {
                high = agg[key]
            }
        })
        return high
    }

    const getExplanation = (question, options, agg) => {
        let highPercent = getHighestPercentage(agg)
        let explanation = ''
        let optionIds = []
        agg && Object.keys(agg).forEach(key => {
            if (agg[key] == highPercent) {
                optionIds.push(Number(key))
            }
        })
        if (question.responseType == MCQ || question.responseType == OPINIONATED) {
            options && options.forEach(opt => {
                if (optionIds.includes(opt.id)) {
                    explanation = explanation + `${highPercent} ${opt.explanation ? opt.explanation : ' percent have chosen ' + opt.name + '.'} `
                }
            })
        } else if (question.responseType == SLIDER) {
            explanation = `${highPercent}% of the attendees have chosen ${optionIds.join(', ')} as their response.`
        } else if (question.responseType == LIKE_DISLIKE) {
            explanation = `${highPercent}% of the attendees have responded with a ${optionIds.includes(1) ? 'like' : 'dislike'}.`
        } else if (question.responseType == STAR) {
            explanation = `${highPercent}% of the attendees have responded with a ${optionIds.join(', ')} star rating.`
        } else if (question.responseType == SMILEY) {
            explanation = <div>
                {highPercent}% of the attendees have responded with a {optionIds.map(opt => {
                return <img className='mr-4' width={20} height={20} src={EMOJI_NUMBER_MAPPING[opt]} alt=''/>
            })} star rating.
            </div>
        }
        return explanation;
    }

    return (
        <DrawerBox visible={open} setVisible={handleCloseSummaryModal} closeIcon={null} maskClosable={true}
                   height={'90vh'} width='450px' placement={isMobile ? 'bottom' : 'right'}
                   headerStyle={{display: 'none'}} bodyStyle={{background: '#23262f'}}>
            <div className='flex fd-row items-center jc-space-between mt-16 pl-16 pr-16'>
                <h3 className='font-size-20 font-bold-700 font-color-white'>Summary so far</h3>
                <Button type='link' size='medium' danger ghost onClick={handleCloseSummaryModal}
                        className='flex fd-row items-center font-size-16'>
                    <AiOutlineClose className='mr-4'/>
                    Close
                </Button>
            </div>
            {isAdmin ? <div className='m-16 flex jc-space-between'>
                <div type='primary' size='large' onClick={sendOutSectionSummary}
                     className='button-gradient font-bold-600 flex-grow-1 jc-center flex items-center pt-6 pb-6 rounded-12 font-color-white cursor-pointer'
                     style={{border: 'none'}}>
                    <AiFillPushpin className='mr-8'/> Push To All Users
                </div>
            </div> : ''}
            {isAdmin ? <div className='font-size-14 font-color-red font-bold-500 m-16 block'>
                <i>Note : Please send out the section summary only after sending all questions in the section.</i>
            </div> : ''}
            <h3 className='font-size-24 font-bold-700 font-color-3 mt-16 ml-16'>Know Your Speakers</h3>
            <hr style={{margin: '8px 16px', opacity: 0.15}}/>
            <Swiper slidesPerView={1} spaceBetween={8} navigation={true} freeMode={true} autoplay={false}
                    modules={[FreeMode, Navigation]} className=''>
                {sectionSummary && sectionSummary.experts && sectionSummary.experts.map(expert => {
                    return <SwiperSlide>
                        <div className='flex fd-row items-center mt-16 pl-16 pr-16'>
                            <div className='width-80 height-80 rounded-12 o-hidden mr-20 flex-shrink-0'>
                                <img src={expert.profilePic ? expert.profilePic : DefaultProfileIcon} alt={expert.name}
                                     className='width-full height-full'/>
                            </div>
                            <div>
                                <h3 className='font-size-18 font-bold-700 font-color-white'>{expert.name}</h3>
                                <p className='font-size-16 font-color-white'>{expert.designation}</p>
                                <p className='font-size-16 font-color-white'>{expert.qualification}</p>
                            </div>
                        </div>
                        <ReadMoreLess charLimit={300} className='font-size-16 font-color-white mb-16 mt-16 pl-16 pr-16'
                                      readMoreLessClass={'font-color-3 font-bold-500 cursor-pointer'}
                                      content={expert.bio ? expert.bio.trim() : ''}/>
                    </SwiperSlide>
                })}
            </Swiper>

            <div className='question-summary-box-container'>
                {sectionSummary && sectionSummary.questionWiseSummary && sectionSummary.questionWiseSummary.filter(question => question.topChoiceExplanation).map((question, idx) => {
                    return <div className='question-summary-box-outer'>
                        <div
                            className={`question-summary-box ${idx % 2 === 0 ? 'items-flex-end' : 'items-flex-start'}`}>
                            <div className='question-summary-box-metrix'>
                                <span>{getHighestPercentage(question.agg)}{percentageTag}</span>
                            </div>
                            <div className='question-summary-box-contents'>
                                <p className='font-size-20 font-bold-700 opacity-6'>Question</p>
                                <p className='font-size-14 mt-4'
                                   dangerouslySetInnerHTML={{__html: question.question.name}}/>
                                <p className='font-size-20 font-bold-700 opacity-6 mt-16'>Top Choice</p>
                                {/* <p className='font-size-14 mt-4'>{getExplanation(question.question, question.questionOptions, question.agg)}</p> */}
                                <p className='font-size-14 mt-4'
                                   dangerouslySetInnerHTML={{__html: question.topChoiceExplanation}}/>
                            </div>
                        </div>
                    </div>
                })}
            </div>
        </DrawerBox>
    )
}

export default SectionSummaryDrawer
